import { draw } from 'patternomaly';

export const chartColors = {
  brand: 
  ['#B8FFEC',
    '#54FFD1',
    '#00EBAB',
    '#00B886',
    '#008561',
    '#00523C',
    '#001F16',
    '#FFF2A3',
    '#FFEA66',
    '#54FFD1',
    '#E0C200',
    '#AD9600',
    '#7A6A00',
    '#473E00',
    '#97BFA1',
    '#78AB84',
    '#5C946A',
    '#487553',
    '#34543C',
    '#29422F',
    '#1F3224',
    '#D7D5CE',
    '#C1BEB3',
    '#AAA697',
    '#938E7B',
    '#797463',
    '#5D594C',
    '#413E35',
    '#B2B4B9',
    '#979BA0',
    '#7C8188',
    '#64686D',
    '#4B4E53',
    '#333538',
    '#1B1C1D'
  ],
  peach: ['#FED9C6', '#555A5F', '#1D1D1B', '#FEEDE4', '#E5E5E5', '#F2B291', '#A6A8B0', '#555A5F'],
  teal: ['#54FFD1', '#333538'],
};

export const chartPatterns = [
  'cross',
  'plus',
  'dash',
  'dot',
  'line',
  'line-vertical',
  'zigzag',
  'square',
  'box',
  'triangle',
  'diamond',
] as const;

export type ChartPatterns = typeof chartPatterns[number];

export const peachPatterns = [
  ...chartColors.peach,
  ...chartPatterns.map((pattern) => chartColors.peach.map((color) => draw(pattern, color))).flat(),
];

export const brandColours = [
  ...chartColors.brand,
  ...chartColors.brand,
  ...chartColors.brand,
];
